import { render, staticRenderFns } from "./options.vue?vue&type=template&id=4b0d39f6&scoped=true"
import script from "./options.vue?vue&type=script&lang=js"
export * from "./options.vue?vue&type=script&lang=js"
import style0 from "./options.vue?vue&type=style&index=0&id=4b0d39f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0d39f6",
  null
  
)

export default component.exports